<template>
  <bk-view class="reserveMemberInfo-container">

    <bk-view class="view-member-main" v-if="isMember">
			<bk-view class="view-blocked-main" v-if="reserveBlackInfo?.blacklistStatus===1 || reserveBlackInfo.noShowCount">
				<bk-view class="view-blocked-item" v-if="reserveBlackInfo.noShowCount">
					<bk-icon icon="icon-shuangyue1"></bk-icon>
					<bk-lang code="appointment_noShow" suffix=":"></bk-lang>
					<span>{{ reserveBlackInfo.noShowCount  }}</span>
					<bk-lang code="appointment_updateCalendar_times"></bk-lang>
				</bk-view>
				<bk-view class="view-blocked-item" v-if="reserveBlackInfo?.blacklistStatus===1">
					<bk-icon icon="icon-lahei"></bk-icon>
					<bk-lang code="appointment_updateCalendar_blocked"></bk-lang>
				</bk-view>
			</bk-view>
			<bk-view class="view-info">
				<bk-view class="view-memberCard" @click="setShowPage('customersDetail')">
					<bk-view class="view-del" v-if="editable" @click.stop="handleItemClick('delMember')"></bk-view>
					<bk-view class="view-mark"></bk-view>
					<bk-view class="view-box">
						<bk-view class="view-top-main">
							<span class="view-name">{{ showMemberInfo.name }}</span>
							<span>No.{{ showMemberInfo.code }}</span>
						</bk-view>
						<bk-view class="view-list">
							<bk-view class="view-item">
								<bk-icon icon="icon-call" />
								<span>{{ showMemberInfo.mobile }}</span>
							</bk-view>
							<bk-view class="view-item">
								<bk-icon icon="icon-email" />
								<span>{{ showMemberInfo.email }}</span>
							</bk-view>
						</bk-view>
					</bk-view>
				</bk-view>
				<bk-view class="view-note">
					<bk-lang code="appointment_updateCalendar_note" suffix="："></bk-lang>
					<bk-view class="view-text">{{ showMemberInfo.remark || '-' }}</bk-view>
				</bk-view>
			</bk-view>
    </bk-view>

    <bk-view class="view-fit-main" v-else>
      <bk-view class="view-box">
        <bk-view class="view-top-main">
          <bk-view class="view-leftInfo">
            <bk-lang code="appointment_updateCalendar_phone" suffix="："></bk-lang>
						<span>{{ reserveInfo.contactMobile }}</span>
          </bk-view>
        </bk-view>
        <bk-view class="view-list">
          <bk-view class="view-item">
            <bk-lang code="appointment_updateCalendar_contactEmail"  suffix="："></bk-lang>
						<span>{{ reserveInfo.contactEmail }}</span>
          </bk-view>
          <bk-view class="view-item">
            <bk-lang code="appointment_updateCalendar_name"  suffix="："></bk-lang>
            <span class="view-text">{{ reserveInfo.contactName }}</span>
          </bk-view>
        </bk-view>
      </bk-view>
    </bk-view>
  </bk-view>
</template>

<script>
	import {customerReq, authReq } from '@/reqService';

	export default {
		name:'reserveMemberInfo',
		props:{
			editable:Boolean,
			reserveInfo:Object,
		},
		data (){
			return {
				showMemberInfo:{},
				showPage:'',
			};
		},
		computed:{
			isMember () { 
				const { memberId, memberInfo } = this.reserveInfo;
				return this.$bk_notNull(memberId) || this.$bk_notNull(memberInfo);
			},
			reserveBlackInfo (){
				const { reserveBlacklist={} } = this.showMemberInfo;
				return reserveBlacklist;
			}
		},
		watch:{
			'reserveInfo.memberInfo' (){
				this.requestGetMemberInfo();
			}
		},
		mounted (){
			this.requestGetMemberInfo();
		},
		methods:{
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			async requestGetMemberInfo () {
				const { memberInfo, memberId } = this.reserveInfo;
		
				if(!memberInfo?.id && !memberId){
					this.showMemberInfo = {};
					return false;
				}

				let res = await customerReq.requestGetMemberDetail(this, {id: memberInfo?.id || memberId }).catch(() => {});

				if(!res?.id){
					this.showMemberInfo = memberInfo;
				}else {
					this.showMemberInfo = res;
				}

				this.decrypt();

			},
			async decrypt (){
				const { mobile, email, id } = this.showMemberInfo;
				// 解密
				let decryptParams = { id, type:'member'};
					
				if(mobile?.indexOf('*') !=-1){
					this.showMemberInfo.mobile = await authReq.requestGetScenesMobile(this, decryptParams);
				}

				if(email?.indexOf('*') !=-1){
					this.showMemberInfo.email = await authReq.requestGetScenesEmail(this, decryptParams);
				}
			},
			handleItemClick (action){
				this.$emit('action', { action });
			},
			handleNativeClick (action){
				if(action==='mobile'){
					this.$bk_nativeMakeCall({ id: this.reserveInfo.id, type: 'reserve'});
				}

				if(action==='email'){
					this.$bk_nativeSendEmail(null, { id: this.reserveInfo.id, type: 'reserve'});
				}
			}
		}
	};
</script>

<style lang="less">
@import './reserveMemberInfo.less';
</style>


